import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ItemService, StreamService, UserService, UtilService } from '../services'
import { UserStreamsRequestModel } from '../model';
import { Subject } from "rxjs";
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import * as _ from 'lodash';
import { first, filter, takeUntil } from 'rxjs/operators';
import { ItemEditContextModel } from '../services/item.service';

@Component({
    selector: 'digest-container',
    styles: [`
        mat-sidenav.sidebar {
            width: 300px;
        }
        
        .big-icon {
            font-size: 20px
        }
        
        .menu-label {
            margin-top: 5px;
            margin-bottom: 0px;
            margin-left: 3px;
        }
        
        .selected-menu-item {
            background: #D7D7D7;
        }
        
        .menu-button {
            padding: 0px;
            min-width: 35px;
        }
        
        .left-menu-button {
            margin-right: 10px;
        }
        
        mat-sidenav-container {
            height: calc(100vh - 65px) !important; 
            min-height: calc(100vh - 65px) !important;
        }

        .menuButtonHolder {
            min-height: 40px;
            max-height: 40px;
        }
    `],
    template: `
        <mat-toolbar color="primary">
            <button mat-button class="left-menu-button menu-button" *ngIf="!isLargeScreen() && !isItemRoute" (click)="toggleSidebar(sideNav)"><i class="big-icon fa fa-bars"></i></button>            
            <span fxFlex *ngIf="!isLargeScreen() && (isItemRoute || isTopicRoute)" class="left-menu-button menu-button"></span>
            <app-nav></app-nav>
            <span fxFlex></span>
            <logo *ngIf="showLogo"></logo>
            <span fxFlex></span>
            <create-topic-link></create-topic-link>
            <app-right-nav></app-right-nav>
        </mat-toolbar>
        <mat-sidenav-container fxFill>
            <mat-sidenav [mode]="isLargeScreen() ? 'side' : 'over'" opened="true" #sideNav fxLayout="column" class="sidebar">
                <div fxLayout="column">
                    <div *ngIf="showItem('recent')"
                        fxFlex 
                        fxLayout="row" 
                        class="menuButtonHolder" 
                        [ngClass]="{'selected-menu-item': selectedItem === 'recent' }">
                        <menu-button fxFlex icon="schedule" label="Recent" [link]="['./recent']"></menu-button>
                    </div>
                    <div *ngIf="showItem('bookmarked')"
                        fxFlex 
                        fxLayout="row" 
                        class="menuButtonHolder" 
                        [ngClass]="{'selected-menu-item': selectedItem === 'bookmarked' }">
                        <menu-button fxFlex [icon]="bookmarkLabel" label="Bookmarked" [link]="['./bookmarked']"></menu-button>
                    </div>
                    <div *ngIf="showItem('recommended')"
                        fxFlex 
                        fxLayout="row" 
                        class="menuButtonHolder" 
                        [ngClass]="{'selected-menu-item': selectedItem === 'recommended' }">
                        <menu-button fxFlex icon="lightbulb_outline" label="Recommended" [link]="['./recommended']"></menu-button>
                    </div>
                    <div *ngIf="showItem('mostread')"
                        fxFlex 
                        fxLayout="row" 
                        class="menuButtonHolder" 
                        [ngClass]="{'selected-menu-item': selectedItem === 'mostread' }">
                        <menu-button fxFlex icon="menu_book" label="Most Read" [link]="['./mostread']"></menu-button>
                    </div>
                    <div *ngIf="showItem('mostliked')"
                        fxFlex 
                        fxLayout="row" 
                        class="menuButtonHolder" 
                        [ngClass]="{'selected-menu-item': selectedItem === 'mostliked' }">
                        <menu-button fxFlex icon="thumb_up" label="Most Liked" [link]="['./mostliked']"></menu-button>
                    </div>
                    <a *ngIf="showBriefings()" [routerLink]="['/briefings']" style="text-decoration: none; color: inherit;">
                        <h3 class="menu-label" style="margin-left: 15px;">
                            <div style="margin-top: 10px; float: left;">Briefings</div>
                        </h3>
                    </a>
                    <h3 *ngIf="showTopics()" class="menu-label" style="margin-left: 15px;">
                        <div style="margin-top: 10px; float: left;">Topics in My Briefing</div>
                    </h3>
                    <span *ngIf="showTopics() && taxonomy.length > 1" style="margin-top: 10px;">
                        <category-card *ngFor="let category of taxonomy | includedCategory : taxonomyMap"
                                    [title]="category.title"
                                    [isOpen]="categorySelectedMap[category.id]"
                                    (toggleOpen)="categorySelectedMap[category.id] = !categorySelectedMap[category.id]">
                            <topic-menu-button *ngFor="let topic of topicsForCategory(category)" [categoryId]="category.id" [selectedItem]="selectedItem" [topic]="topic" [subscription]="subscriptions[topic.id]"></topic-menu-button>
                        </category-card>
                    </span>
                    <span *ngIf="showTopics() && taxonomy.length > 1">
                        <category-card *ngIf="uncategorizedTopics().length"
                                    title="Uncategorized" 
                                    [isOpen]="categorySelectedMap['uncategorized']"
                                    (toggleOpen)="categorySelectedMap['uncategorized'] = !categorySelectedMap['uncategorized']">
                            <topic-menu-button *ngFor="let topic of uncategorizedTopics()" categoryId="uncategorized" [selectedItem]="selectedItem" [topic]="topic"  [subscription]="subscriptions[topic.id]"></topic-menu-button>
                        </category-card>
                    </span>
                    <span *ngIf="showTopics() && taxonomy.length < 2" style="margin-top: 10px;">
                        <topic-menu-button *ngFor="let topic of uncategorizedTopics()" categoryId="uncategorized" [selectedItem]="selectedItem" [topic]="topic"  [subscription]="subscriptions[topic.id]"></topic-menu-button>
                    </span>
                </div>
            </mat-sidenav>
            <router-outlet></router-outlet>
            <mat-sidenav [autoFocus]="false" mode="over" position="end" #rightSideNav (closedStart)="closingTime()">
                <item-viewer *ngIf="focusedItemContext" 
                             [itemContext]="focusedItemContext"
                             [curating]="focusedItemContext?.isCuration"
                             (close)="close()"></item-viewer>
                <div *ngIf="focusedItemEditContext">
                    <item-post [itemEditContextModel]="focusedItemEditContext"
                               (done)="close(100)"></item-post>
                </div>
            </mat-sidenav>
        </mat-sidenav-container>
    `
})
export class ReaderComponent implements OnInit, OnDestroy {
    @ViewChild('rightSideNav', { static: true }) rightSideNav;
    private cleanupTime = new Subject<void>();
    forcedClosed: boolean;
    focusedItemContext: any;
    mqAlias: string; 
    selectedItem: string;
    isTopicRoute: boolean;
    isItemRoute: boolean;
    isRecentRoute: boolean;
    isMostReadRoute: boolean;
    isMostLikedRoute: boolean;
    isBookmarkedRoute: boolean;
    isRecommendedRoute: boolean;
    bookmarkLabel = 'bookmark_outline';
    taxonomy =  [];
    taxonomyMap: object = {};
    childCategoryToParentMap: object = {};
    streams: any = [];
    categorySelectedMap: object = {};
    selectedCategory: object;
    hideCategories: boolean = false;
    @ViewChild('sideNav', { static: true }) sideNav;
    tenant: any;
    showLogo: boolean;
    subscriptions: any = {};
    focusedItemEditContext: ItemEditContextModel;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private itemService: ItemService,
                private streamService: StreamService,
                private userService: UserService,
                utilService: UtilService,
                media: MediaObserver) {

        this.route.data.pipe(first()).subscribe(data => {
            this.tenant = data.tenant;
            this.hideCategories = this.tenant.settings.hideCategories === 'true' || this.tenant.settings.hideHomeCategories === 'true';
            this.showLogo = _.isEmpty(this.tenant.settings.logoUrl);
            this.taxonomy = data.taxonomy.filter(category => !this.hideCategories || category.id === 'uncategorized');
            this.taxonomy.forEach(category => category.subcategories.forEach(subcat => this.childCategoryToParentMap[subcat.id] = category.id));
            this.categoryCheck();
        });

        media.media$.pipe(takeUntil(this.cleanupTime))
        .subscribe((change: MediaChange) => {
            this.mqAlias = change.mqAlias;
            this.configureSidebar();
        });

        this.itemService.bookmarkChanges.pipe(takeUntil(this.cleanupTime)).subscribe(() => this.configureBookmarkIcon());

        this.router.events.pipe(filter(evt => evt instanceof NavigationEnd), takeUntil(this.cleanupTime))
        .subscribe(() => {
            this.userService.fetchCurrentUser().subscribe(currentUser => this.subscriptions = _.keyBy(currentUser.subscriptions, 'streamId'));
            this.categoryCheck();
            ['recent', 'mostread', 'mostliked', 'bookmarked', 'recommended', 'search']
            .forEach(seg => this.selectedItem = utilService.hasUrlSeg(seg) ? seg : this.selectedItem);
            this.isRecentRoute = utilService.hasUrlSeg('recent');
            this.isMostReadRoute = utilService.hasUrlSeg('mostread');
            this.isMostLikedRoute = utilService.hasUrlSeg('mostliked');
            this.isBookmarkedRoute = utilService.hasUrlSeg('bookmarked');
            this.isRecommendedRoute = utilService.hasUrlSeg('recommended');
            this.isTopicRoute = utilService.hasUrlSeg('topics');
            this.isItemRoute = utilService.hasUrlSeg('items');
            this.configureSidebar();
            this.configureBookmarkIcon();
        });
        this.categoryCheck();
    }

    ngOnInit() {
        this.itemService.focusedItemEdit.pipe(takeUntil(this.cleanupTime))
        .subscribe(context => {
            this.focusedItemEditContext = context;
            if (context) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });
        
        this.itemService.focusedItem.pipe(takeUntil(this.cleanupTime))
        .subscribe(item => {
            this.focusedItemContext = item;
            if (item) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });
        this.fetchSubscribed();
        this.streamService.streamUpdates.pipe(takeUntil(this.cleanupTime)).subscribe(stream => {
            if(stream){
                stream.userIsFollowing ? this.streams.push(stream) : this.streams.splice(this.streams.findIndex(st => st.id === stream.id), 1);
                this.processStreams();
            }
        });
    };

    private categoryCheck(){
        if(this.route.firstChild) {
            this.route.firstChild.params.pipe(first())
            .subscribe(params => {
                const childId = this.childCategoryToParentMap[params.categoryId];
                if (params && params.categoryId) {
                    this.categorySelectedMap[childId || params.categoryId] = true;
                }
                if (params && params.topicId && this.hideCategories) {
                    this.selectedItem = 'uncategorized-' + params.topicId;
                }else if (params && params.topicId) {    
                    this.selectedItem = childId ? (childId + '-' + params.topicId) : (params.categoryId + '-' + params.topicId);
                }
            });
        }
    };

    configureBookmarkIcon = () => this.itemService.getBookmarkedItems({ page: 0, includeFullDescription: true, sortField: 'publishedDate' })
        .subscribe(itemResults => this.bookmarkLabel = itemResults.totalElements ? 'bookmark' : 'bookmark_border');

    configureSidebar() {
        if ((this.sideNav && this.mqAlias === 'xs')
        || ((this.isBookmarkedRoute || this.isRecentRoute || this.isRecommendedRoute || this.isMostReadRoute || this.isMostLikedRoute) && this.mqAlias === 'xs')) {
            setTimeout(() => this.sideNav.close());
        } else if(this.sideNav && !this.isItemRoute && !this.forcedClosed) {
            setTimeout(() => this.sideNav.open());
        }
    };

    isLargeScreen() {
        return this.mqAlias !== 'xs';
    }

    toggleSidebar(sidebar){
        this.forcedClosed = sidebar.opened;
        sidebar.toggle();
    }

    uncategorizedTopics() {
        if(this.hideCategories) {
            return this.streams || [];
        } else {
            return this.streams ? this.streams.filter(stream => !stream.taxonomicMemberships || stream.taxonomicMemberships.length === 0) : [];
        }
    }
    
    get noLabel(): boolean {
        return !!this.route.snapshot.queryParams.returnTo;
    }

    topicsForCategory(category) {
        return this.streams ? this.streams.filter(stream => _.includes(stream.taxonomicMemberships, category.id) || category.subcategories.reduce((acc, subcat) => acc || _.includes(stream.taxonomicMemberships, subcat.id), false)) : [];
    }

    itemBack() {
        if (this.route.snapshot.queryParams.returnTo) {
            this.router.navigateByUrl(this.route.snapshot.queryParams.returnTo);
        } else {
            let route = this.route;
            while(route.firstChild){
                route = route.firstChild;
            }
            this.router.navigate(['.'], {relativeTo: route.parent, queryParamsHandling: 'merge'});
        }
    };

    returnToSource = () => {
        if (this.route.snapshot.queryParams.source) {
            this.router.navigateByUrl(this.route.snapshot.queryParams.source);
        } else {
            this.router.navigate(['/digest', 'recent']);
        }
    }

    processStreams = () => {
        const taxonomyMap = {};
        this.streams.forEach(stream => {
            stream.taxonomicMemberships.forEach(taxonomyId => {
                if(!taxonomyMap[taxonomyId]){
                    taxonomyMap[taxonomyId] = [];
                }
                taxonomyMap[taxonomyId].push(stream);
            })
        });
        this.taxonomyMap = taxonomyMap;
    };

    fetchSubscribed = () => this.streamService.getUserStreams(new UserStreamsRequestModel(this.userService.getCurrentUser().id)).pipe(first())
        .subscribe(streams => {
            this.streams = streams.content;
            this.processStreams();
        });

    showBriefings() {
        return this.tenant && 
               this.tenant.settings && 
               this.tenant.settings.clientDigestMenuOptions && 
               (this.tenant.settings.clientDigestMenuOptions.length === 0 || this.tenant.settings.clientDigestMenuOptions.indexOf('briefings') !== -1);  
    }

    showItem(item) {
        return this.tenant && this.tenant.settings && 
        (!this.tenant.settings.clientDigestMenuOptions || this.tenant.settings.clientDigestMenuOptions.indexOf(item) !== -1);
    }

    showTopics() {
        return this.tenant && this.tenant.settings && (!this.tenant.settings.clientDigestMenuOptions || this.tenant.settings.clientDigestMenuOptions.length !== 0);
    }

    closingTime(): void {
        this.itemService.itemClosing.next();
    }

    close(wait = 0): void {
        setTimeout(() => this.rightSideNav.close(), wait);
    }

    ngOnDestroy() {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    };
}
